import { createFileRoute } from "@tanstack/react-router";
import IrrigationSystemEditor from "@/components/field/setup/IrrigationSystemEditor";

export const Route = createFileRoute(
    "/dashboard/fields/$fieldId/setup/irrigation-system/$irrigationSystemId",
)({
    component: IrrigationSystemEditPane,
});

function IrrigationSystemEditPane() {
    const { irrigationSystemId } = Route.useParams();
    return <IrrigationSystemEditor irrigationSystemId={irrigationSystemId} />;
}
